import { IOGImage } from '@lemon8/web-app-shared/ssr';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableDiscoverDataOrNull } from './atom';
import { EArticleClass } from 'shared/models';
import { loadable } from 'jotai/utils';

export const useDiscoverCover: () => IOGImage | null = () => {
  const loadableDiscoverData = useAtomValue(loadable($CurrentAvailableDiscoverDataOrNull));

  if (loadableDiscoverData.state !== 'hasData') {
    return null;
  }

  const discoverData = loadableDiscoverData.data;

  if (!discoverData) {
    return null;
  }
  if (discoverData.article_v2.items.length > 0) {
    const ogImageMeta =
      discoverData.article_v2.items[0].article.articleClass === EArticleClass.GALLERY
        ? {
            url: discoverData.article_v2.items[0].article.imageList[0].shareCardCoverImage || '',
            width: discoverData.article_v2.items[0].article.imageList[0].width,
            height: discoverData.article_v2.items[0].article.imageList[0].height,
          }
        : {
            url: discoverData.article_v2.items[0].article.largeImage.shareCardCoverImage || '',
            width: discoverData.article_v2.items[0].article.largeImage.width,
            height: discoverData.article_v2.items[0].article.largeImage.height,
          };
    return ogImageMeta;
  } else {
    return null;
  }
};
